import React, { createContext, ReactNode, useState } from 'react'
import { iFormDialog } from './index'
import Component from './Component'

// @ts-ignore
export const FormDialogContext = createContext<{
  actions: {
    open: (
      title: string,
      content: string,
      fields: {
        name: string
        placeholder: string
        label: string
        rows?: number
        type?: React.InputHTMLAttributes<unknown>['type']
        options?: ReactNode
      }[],
      initialValues: any,
      validationSchema: any,
      submit: any,
      buttonsInfo: { okText: string; cancelText?: string; loadingButton?: boolean },
      additionalInfo?: null | ((value: any) => string),
      additionalInfoTitle?: string
    ) => void
    close: () => void
  }
  store: Partial<iFormDialog>
}>({
  // @ts-ignore
  actions: {},
  store: {
    isOpen: false,
    content: '',
    title: '',
    cancelText: 'Close',
    okText: 'Ok'
  }
})

export const FormDialogProvider: React.FC = ({ children }) => {
  const [dialog, setDialog] = useState<iFormDialog>({
    isOpen: false,
    content: '',
    fields: [],
    title: '',
    initialValues: {},
    validationSchema: null,
    submit: null,
    cancelText: 'Cancel',
    okText: 'Ok',
    additionalInfo: null,
    additionalInfoTitle: '',
    loadingButton: false
  })

  const open = (
    title: string,
    content: string | ReactNode,
    fields: {
      name: string
      placeholder: string
      label: string
      options?: ReactNode
    }[],
    initialValues: any,
    validationSchema: any,
    submit: any,
    buttonsInfo?: { okText?: string; showOk?: boolean; cancelText?: string; loadingButton?: boolean },
    additionalInfo?: null | ((value: any) => string),
    additionalInfoTitle?: string
  ) => {
    setDialog({
      ...dialog,
      isOpen: true,
      title,
      content,
      fields,
      validationSchema,
      initialValues,
      submit,
      ...buttonsInfo,
      additionalInfo,
      additionalInfoTitle
    })
  }

  const close = () => {
    setDialog({
      isOpen: false,
      title: '',
      content: '',
      fields: [],
      initialValues: {},
      validationSchema: null,
      submit: null,
      cancelText: 'Cancel',
      okText: 'Ok',
      additionalInfo: null,
      additionalInfoTitle: '',
      loadingButton: false
    })
  }

  return (
    <FormDialogContext.Provider
      value={{
        actions: {
          close,
          open
        },
        store: dialog
      }}
    >
      {dialog.isOpen && <Component />}
      {children}
    </FormDialogContext.Provider>
  )
}
